//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.5'.
//
package graphql

import com.apollographql.apollo3.annotations.ApolloAdaptableWith
import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.CompiledField
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.Query
import com.apollographql.apollo3.api.json.JsonWriter
import com.apollographql.apollo3.api.obj
import graphql.adapter.GetAllTradeNewsQuery_ResponseAdapter
import graphql.selections.GetAllTradeNewsQuerySelections
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.Unit
import kotlin.collections.List

public class GetAllTradeNewsQuery() : Query<GetAllTradeNewsQuery.Data> {
  public override fun equals(other: Any?): Boolean = other != null && other::class == this::class

  public override fun hashCode(): Int = this::class.hashCode()

  public override fun id(): String = OPERATION_ID

  public override fun document(): String = OPERATION_DOCUMENT

  public override fun name(): String = OPERATION_NAME

  public override fun serializeVariables(writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters): Unit {
    // This operation doesn't have any variable
  }

  public override fun adapter(): Adapter<Data> = GetAllTradeNewsQuery_ResponseAdapter.Data.obj()

  public override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = graphql.type.Query.type
  )
  .selections(selections = GetAllTradeNewsQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(GetAllTradeNewsQuery_ResponseAdapter.Data::class)
  public data class Data(
    /**
     * 全てのトレードニュースを取得します（データベースから）
     * 	
     * 最新100件のニュースを返します
     */
    public val tradeNews: List<TradeNew>,
  ) : Query.Data

  public data class TradeNew(
    /**
     * ニュースの一意識別子
     */
    public val id: String,
    /**
     * ニュースのタイトル
     */
    public val title: String,
    /**
     * ニュースの説明文
     */
    public val description: String?,
    /**
     * ニュースへのリンク
     */
    public val link: String,
    /**
     * ニュースソース（ESPN、RealGMなど）
     */
    public val source: String,
    /**
     * 公開日時
     */
    public val publishedAt: String,
    /**
     * カテゴリー（Trade、Signing、Other）
     */
    public val category: String,
    /**
     * 日本語タイトル
     */
    public val titleJa: String?,
    /**
     * 日本語説明文
     */
    public val descriptionJa: String?,
    /**
     * 翻訳ステータス
     */
    public val translationStatus: String,
    /**
     * 翻訳日時
     */
    public val translatedAt: String?,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "16e7869939e8ae6a5558c2251a5b2620174ed3fecd9544ae81fbcbbe32c57e55"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * query GetAllTradeNews {
     *   tradeNews {
     *     id
     *     title
     *     description
     *     link
     *     source
     *     publishedAt
     *     category
     *     titleJa
     *     descriptionJa
     *     translationStatus
     *     translatedAt
     *   }
     * }
     */
    public val OPERATION_DOCUMENT: String
      get() =
          "query GetAllTradeNews { tradeNews { id title description link source publishedAt category titleJa descriptionJa translationStatus translatedAt } }"

    public const val OPERATION_NAME: String = "GetAllTradeNews"
  }
}
